import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const BreadCrumbItemWrapper = styled(Box)`
  cursor: pointer;
  gap: 4px;

  &:hover {
    p {
      color: ${({ theme }) => getThemeColor('white', theme)};
    }
  }
`
